import React, { createContext, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc } from 'firebase/firestore';
import { getDocFromServer } from '../utils/firestoreRead';
import { db } from '../firebase/firebaseConfig';
import { useAuth } from '../context/AuthContext';
import { puedeAccederEvento } from '../utils/accessPolicy';

const EventoVerificado = createContext(null);
export const useEventoVerificado = () => useContext(EventoVerificado);

// Control visual del módulo; las Rules aplican la autorización de datos.
export default function EventPermission({ permiso, children }) {
  const { eventoId } = useParams();
  const { profile } = useAuth();
  const [checked, setChecked] = useState(null);
  useEffect(() => {
    let alive = true;
    setChecked(null);
    getDocFromServer(doc(db, 'eventos', eventoId)).then((snap) => {
      if (alive) setChecked({ profile, eventoId, permiso, evento: snap.exists() ? { ...snap.data(), id: snap.id } : null, allowed: snap.exists() && puedeAccederEvento(profile, { ...snap.data(), id: snap.id }, permiso) });
    }).catch(() => { if (alive) setChecked({ profile, eventoId, permiso, evento: null, allowed: false }); });
    return () => { alive = false; };
  }, [profile, eventoId, permiso]);
  if (!checked || checked.profile !== profile || checked.eventoId !== eventoId || checked.permiso !== permiso) return <div>Cargando…</div>;
  return checked.allowed ? <EventoVerificado.Provider value={checked}>{children}</EventoVerificado.Provider> : <div>ACCESO NO AUTORIZADO</div>;
}
